import { useMediaQuery, useTheme } from '@mui/material';

export const useScreenBreakpoints = () => {
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(
    `(min-width: ${theme.breakpoints.values['sm']}px) and (max-width: ${
      theme.breakpoints.values['lg'] - 1
    }px)`
  );
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  return {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen
  };
};
